import React from "react";
import { FormControl, InputGroup, FormGroup, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DayPicker from 'react-day-picker';
import moment from 'moment';

function getWeekDays(weekStart) {
    const days = [weekStart];
    for (let i = 1; i < 7; i += 1) {
        days.push(
            moment(weekStart)
            .add(i, 'days')
            .toDate()
        );
    }
    return days;
}
  
function getWeekRange(date) {
    return {
        from: moment(date)
        .startOf('week')
        .toDate(),
        to: moment(date)
        .endOf('week')
        .toDate(),
    };
}

export default class WeekPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hoverRange: undefined,
            selectedDays: [],
            month: null
        };

        this.onClick = this.onClick.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleDayEnter = this.handleDayEnter.bind(this);
        this.handleDayLeave = this.handleDayLeave.bind(this);
        this.handleWeekClick = this.handleWeekClick.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onWeekEndingDateChange = this.onWeekEndingDateChange.bind(this);
    }

    componentDidMount() {
        if (this.props.vm != null) {
            this.setState({
                selectedDays: getWeekDays(new Date(this.props.vm.defaultWeek.startDate)),
                month: new Date(this.props.vm.defaultWeek.startDate)
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.selectedDays.length > 0 && nextProps.vm != null) {
            if ((new Date(nextProps.vm.weekEndingDate)).getTime() != (new Date(this.state.selectedDays[6])).getTime()) {
                this.setState({
                    selectedDays: getWeekDays(getWeekRange(new Date(nextProps.vm.weekEndingDate)).from),
                    month: new Date(nextProps.vm.weekEndingDate)
                });
            }
        }
    }

    handleDayChange(date)  {
        var selectedDays = getWeekDays(getWeekRange(date).from); 
        
        this.setState({
            open: false,
            selectedDays: selectedDays,
        });


        this.onWeekEndingDateChange(selectedDays[6], this.props.onSearch);
    }

    onWeekEndingDateChange(value, callback) {
        const self = this;

        setTimeout(() => {
            if (self.props.onFieldChange) {
                var weekEndingDate = moment(value).format("MM/DD/YYYY")
                self.props.onFieldChange('weekEndingDate', weekEndingDate, callback);
            }

            if (self.props.updateStatusCount) {
                self.props.updateStatusCount("unverified", 'countSubmittedPrevious', new Date(moment(value).add(-7, 'days')), self.props.vm.approverId, self.props.vm.peopleId);
                self.props.updateStatusCount("unverified", 'countSubmittedNext', new Date(moment(value).add(7, 'days')), self.props.vm.approverId, self.props.vm.peopleId);
            }
        }, 500);
    }    
    
    handleDayEnter(date) {
        this.setState({
            hoverRange: getWeekRange(date),
        });
    }
    
    handleDayLeave() {
        this.setState({
            hoverRange: undefined,
        });
    }
    
    handleWeekClick(weekNumber, days, e) {
        this.setState({
            open: false,
            selectedDays: days,
        });    

        this.onWeekEndingDateChange(days[6], this.props.onSearch);
    }

    onClick() {
        var month = new Date(this.state.month);
        this.setState({
            open: true, 
            month: month
        });
    }

    onBlur(event) {
        var inputId = this.props.id + '-input';
        var divId = this.props.id + '-div';

        if ($('#' + inputId).is(":focus") == false && $('#' + divId).is(":hover") == false) {
            this.setState({
                open: false
            });
        }
        else if ($('#' + divId).is(":hover") == true) {
            $('#' + inputId).focus();
        }
    }

    onNavigate(days) {
        var startDate = moment(this.state.selectedDays[0]).add(days, 'days');
        var weekRange = getWeekRange(new Date(startDate));
        var selectedDays = getWeekDays(weekRange.from);

        this.setState({
            selectedDays: selectedDays,
            month: new Date(weekRange.from)
        });

        this.onWeekEndingDateChange(selectedDays[6], this.props.onSearch);
    }

    render() {
        const self = this;
        let vm = this.props.vm;    

        if (vm != null) { 
            const { hoverRange, selectedDays } = this.state;
            const daysAreSelected = selectedDays.length > 0;
            const modifiers = {
                hoverRange,
                selectedRange: daysAreSelected && {
                    from: selectedDays[0],
                    to: selectedDays[6],
                },
                hoverRangeStart: hoverRange && hoverRange.from,
                hoverRangeEnd: hoverRange && hoverRange.to,
                selectedRangeStart: daysAreSelected && selectedDays[0],
                selectedRangeEnd: daysAreSelected && selectedDays[6],
            };

            let inputValue = '';
            if (daysAreSelected == true) {
                inputValue = moment(selectedDays[0]).format("MM/DD/YYYY") + ' - ' + moment(selectedDays[6]).format("MM/DD/YYYY");
            }

            const tooltipPrevious = (
                <Tooltip className="ap-tooltip" id={`tooltip_weekpicker_prev`}>
                    {vm.countSubmittedPrevious} Unverified Timecards
                </Tooltip>
            );

            const tooltipNext = (
                <Tooltip className="ap-tooltip" id={`tooltip_weekpicker_next`}>
                    {vm.countSubmittedNext} Unverified Timecards
                </Tooltip>
            );

            let currentWeekEndingDate = moment(vm.currentWeekEndingDate).format("MM/DD/YYYY");
            let weekEndingDate = moment(vm.weekEndingDate).format("MM/DD/YYYY");

            return (   
                <div>
                    <FormGroup className="ap-tc-verify-week-picker">
                        <InputGroup>
                            <InputGroup.Addon>
                                <div className="ap-tc-verify-week-picker-nav" onClick={(evt) => this.onNavigate(-1)}>
                                    <span><i className="glyphicon glyphicon-menu-left"></i></span>
                                    <span>Prev</span>
                                    <span className="ap-tc-verify-week-picker-unverified">
                                        <OverlayTrigger id={`weekpicker_countSubmittedPrevious`}
                                            placement="top"
                                            overlay={tooltipPrevious}>
                                            <Button>{vm.countSubmittedPrevious}</Button>
                                        </OverlayTrigger>
                                    </span>
                                </div>
                            </InputGroup.Addon>
                            <div>
                                <FormControl id={this.props.id + '-input'} type="text" className={"ap-tc-verify-week-picker-input " + (currentWeekEndingDate != weekEndingDate ? 'not-current-week' : '')} onClick={this.onClick} onBlur={this.onBlur} readOnly={true} value={inputValue} />
                                <div className={"ap-tc-verify-week-picker-calendar " + (this.state.open == true ? '' : 'ap-hidden')}>
                                    <div id={this.props.id + '-div'}>
                                        <DayPicker
                                            selectedDays={selectedDays}
                                            showWeekNumbers
                                            showOutsideDays
                                            modifiers={modifiers}
                                            onDayClick={this.handleDayChange}
                                            onDayMouseEnter={this.handleDayEnter}
                                            onDayMouseLeave={this.handleDayLeave}
                                            onWeekClick={this.handleWeekClick}
                                            initialMonth={new Date(vm.defaultWeek.startDate)}
                                            month={this.state.month}   
                                        />
                                    </div>
                                </div>
                            </div>
                            <span className="input-group-btn ap-tc-verify-week-picker-cal">
                                <Button onClick={this.onClick} onBlur={this.onBlur}>
                                    <i className="glyphicon glyphicon-calendar"></i>
                                </Button>
                            </span>
                            <InputGroup.Addon>
                                <div className="ap-tc-verify-week-picker-nav" onClick={(evt) => this.onNavigate(7)}>
                                    <span>Next</span>
                                    <span className="ap-tc-verify-week-picker-unverified">
                                        <OverlayTrigger id={`weekpicker_countSubmittedNext`}
                                            placement="top"
                                            overlay={tooltipNext}>
                                            <Button>{vm.countSubmittedNext}</Button>
                                        </OverlayTrigger>
                                    </span>
                                    <span><i className="glyphicon glyphicon-menu-right"></i></span>
                                </div>
                            </InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                </div>
            );  
        } else {
            return(
                <div>
                    
                </div>
                );
        }
    }
}